import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import { Elements, StripeProvider } from 'react-stripe-elements';
import CheckoutForm from '../CheckoutForm/CheckoutForm';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class PayWithCard extends Component {
    getStripePublishableKey = () => {	
        return this.props.client.billing_country === 'CA' ?	
            process.env.REACT_APP_STRIPE_CAN : process.env.REACT_APP_STRIPE_US	
    }

    returnToken = (token) => {
        this.props.returnStripeToken(token, this.getStripePublishableKey());
    }

    render() { 
        return ( 
            <React.Fragment>
                <div className="row text-left mb-2">
                    <div className="col-12">
                        <label className="showtix-label">{strings.title}</label>
                    </div>
                </div>

                {!this.props.isDisabled ?
                    <React.Fragment>
                        <StripeProvider
                            apiKey={
                                this.props.client.billing_country === 'CA' ? 
                                process.env.REACT_APP_STRIPE_CAN : 
                                process.env.REACT_APP_STRIPE_US
                            }
                        >
                            <Elements>
                                <CheckoutForm
                                    name={strings.name}
                                    email={this.props.customer.email === '' ? 'tickets@showtix4u.com' : this.props.customer.email}
                                    returnToken={this.returnToken}
                                    country={this.props.client.billing_country}
                                    checkoutInProgress={this.props.checkoutInProgress}
                                />
                            </Elements>
                        </StripeProvider>
                    </React.Fragment>    
                : 
                    <button
                        type="button"
                        className="showtix-button showtix-background__primary-2"
                        disabled
                        aria-labelledby="submit-error-message"
                    >
                        <span>
                            {strings.payWithCard}
                        </span>
                    </button>
                }
            </React.Fragment>   
        )
    }
}

PayWithCard.propTypes = {
    checkout: PropTypes.func
}
 
export default PayWithCard;



// WEBPACK FOOTER //
// ./src/components/Common/PayWithCard/PayWithCard.js